module.exports = __webpack_public_path__ + "static/media/sound1.812c7504.mp3";